(function () {
  'use strict';

  var DEFAULT_BACKEND = 'https://deals.pristineforests.com';

  function money(value, currency) {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: currency || 'INR', maximumFractionDigits: 0
      }).format(value);
    } catch (_) {
      return '₹' + Number(value).toLocaleString('en-IN');
    }
  }

  function subtotalCondition(promotion) {
    var conditions = promotion && promotion.conditions && promotion.conditions.all;
    return Array.isArray(conditions) ? conditions.find(function (condition) {
      return condition.kind === 'subtotal';
    }) : null;
  }

  function selectorLabel(config, selectorId) {
    var selectors = Array.isArray(config.selectors) ? config.selectors : [];
    var selector = selectors.find(function (entry) { return entry.id === selectorId; });
    if (!selector) return 'eligible item';
    if (Array.isArray(selector.productTypes) && selector.productTypes.length) {
      return selector.productTypes.join(' or ');
    }
    if (/travel/i.test(selector.id || '')) return 'travel-size product';
    return 'eligible item';
  }

  function benefitLabel(config, benefit) {
    if (benefit.kind === 'percentage_off') return Number(benefit.percentage) + '% off';
    if (benefit.kind === 'fixed_amount_off') return money(benefit.amount, config.currencyCode) + ' off';
    if (benefit.kind === 'free_shipping') {
      var minimum = Number(benefit.minimumSubtotal || 0);
      return minimum > 0
        ? 'free shipping on carts above ' + money(Math.max(0, minimum - 0.01), config.currencyCode)
        : 'free shipping';
    }
    if (benefit.kind === 'free_per_full_size') return 'a free travel-size product with every eligible full-size product';
    if (benefit.kind === 'free_items') {
      var quantity = benefit.quantity && Number(benefit.quantity.value) || 1;
      var label = selectorLabel(config, benefit.rewardSelectorId);
      return quantity + ' free ' + label + (quantity === 1 || /product$/.test(label) ? '' : 's');
    }
    return '';
  }

  function rangeLabel(config, condition) {
    if (!condition) return '';
    var min = Number(condition.minimum || 0);
    var max = condition.maximum == null ? null : Number(condition.maximum);
    if (min <= 0 && max != null) return ' on eligible carts under ' + money(max, config.currencyCode);
    if (max == null) return ' on eligible carts of ' + money(min, config.currencyCode) + ' or more';
    return ' on eligible carts from ' + money(min, config.currencyCode) + ' to under ' + money(max, config.currencyCode);
  }

  function offerFor(config, promotion) {
    var benefits = (promotion.benefits || []).map(function (benefit) {
      return benefitLabel(config, benefit);
    }).filter(Boolean);
    if (!benefits.length) return null;
    var codes = promotion.trigger && Array.isArray(promotion.trigger.codes) ? promotion.trigger.codes : [];
    return {
      code: codes[0] || '',
      note: codes.length ? 'Use code: ' + codes[0] : 'Applied automatically',
      text: benefits.join(' + ') + rangeLabel(config, subtotalCondition(promotion)) + '.'
    };
  }

  /*
   * Banner set approved by the owner (2026-09-24): the automatic tiers (no
   * label), code-only offers with their code, and one free-
   * shipping line. Samples are not advertised here. Text is derived from the
   * live offer config, so bands and percentages stay in step with the offers.
   */
  function bandLabel(config, condition) {
    if (!condition) return '';
    var min = Number(condition.minimum || 0);
    var max = condition.maximum == null ? null : Number(condition.maximum);
    if (min <= 0 && max != null) return ' on carts under ' + money(max, config.currencyCode);
    if (max == null) return ' on carts of ' + money(min, config.currencyCode) + ' or more';
    return ' on carts from ' + money(min, config.currencyCode) + ' to ' + money(max - 1, config.currencyCode);
  }

  function tierBanner(config, promotion) {
    var percentage = (promotion.benefits || []).find(function (b) { return b.kind === 'percentage_off'; });
    if (!percentage) return null;
    var travel = (promotion.benefits || []).find(function (b) {
      return b.kind === 'free_items' && /travel/i.test(b.rewardSelectorId || '');
    });
    var quantity = travel && travel.quantity && Number(travel.quantity.value) || 1;
    return {
      code: '',
      note: '',
      text: Number(percentage.percentage) + '% off' +
        (travel ? ' + ' + quantity + ' free travel-size product' + (quantity === 1 ? '' : 's') : '') +
        bandLabel(config, subtotalCondition(promotion)) + '.'
    };
  }

  function codeBanner(config, promotion) {
    var code = promotion.trigger.codes[0];
    var perFullSize = (promotion.benefits || []).find(function (b) { return b.kind === 'free_per_full_size'; });
    if (perFullSize && Number(perFullSize.maximumRewardUnits) === 1) {
      return { code: code, note: 'Use code: ' + code, text: '1 free travel-size product with an eligible full-size product.' };
    }
    return offerFor(config, promotion);
  }

  function bannersFor(config) {
    var enabled = (config.promotions || []).filter(function (p) { return p && p.enabled !== false && p.trigger; });
    var lowest = function (p) { var c = subtotalCondition(p); return c ? Number(c.minimum || 0) : 0; };
    var tiers = enabled.filter(function (p) { return p.groupId === 'primary' && p.trigger.automatic === true; })
      .sort(function (a, b) { return lowest(a) - lowest(b); })
      .map(function (p) { return tierBanner(config, p); });
    var codes = enabled.filter(function (p) {
      return p.groupId !== 'samples' && p.trigger.automatic === false &&
        Array.isArray(p.trigger.codes) && p.trigger.codes.length > 0;
    }).sort(function (a, b) { return Number(a.priority || 0) - Number(b.priority || 0); })
      .map(function (p) { return codeBanner(config, p); });
    var shipping = null;
    enabled.forEach(function (p) {
      (p.benefits || []).forEach(function (b) {
        if (b.kind !== 'free_shipping') return;
        var minimum = Math.floor(Number(b.minimumSubtotal || 0));
        if (shipping === null || minimum < shipping) shipping = minimum;
      });
    });
    var banners = tiers.concat(codes).filter(Boolean);
    if (shipping !== null) {
      banners.push({
        code: '',
        note: '',
        text: shipping > 0 ? 'Free shipping on orders of ' + money(shipping, config.currencyCode) + ' or more.' : 'Free shipping.'
      });
    }
    return banners;
  }

  function configUrl() {
    var embed = document.querySelector('[data-pristine-preorder-cart-embed]');
    var shop = embed && String(embed.dataset.shopDomain || '').trim();
    if (!shop) return null;
    var backend = String(embed.dataset.backendUrl || '').trim() || DEFAULT_BACKEND;
    var url;
    try { url = new URL('/api/preorder-cart/config', backend); } catch (_) { return null; }
    if (url.protocol !== 'https:') return null;
    url.searchParams.set('shop', shop);
    return url.toString();
  }

  function render(list, offers) {
    var pattern = list.getAttribute('data-pattern-url') || '';
    var cardClass = list.getAttribute('data-offer-card-class') || 'pdpv1__offer';
    var noteClass = list.getAttribute('data-offer-note-class') || 'pdpv1__offer-note';
    var textClass = list.getAttribute('data-offer-text-class') || 'pdpv1__offer-text';
    var codeClass = list.getAttribute('data-offer-code-class') || 'pdpv1__offer-code';
    var fragment = document.createDocumentFragment();
    offers.forEach(function (offer) {
      var card = document.createElement('div');
      card.className = cardClass;
      if (pattern) {
        var patternValue = 'url("' + pattern.replace(/["\\]/g, '') + '")';
        card.style.setProperty('--pdp-offer-pattern', patternValue);
        card.style.setProperty('--dpdp-offer-pattern', patternValue);
      }
      var body = document.createElement('div');
      var note = document.createElement('p');
      note.className = noteClass;
      note.textContent = offer.note;
      var text = document.createElement('p');
      text.className = textClass;
      text.textContent = offer.text;
      // Automatic offers carry no label (owner 2026-09-24); only code offers do.
      if (offer.note) body.append(note);
      body.append(text);
      if (offer.code) {
        var copy = document.createElement('button');
        copy.type = 'button';
        copy.className = codeClass;
        copy.setAttribute('data-pdp-offer-code', offer.code);
        copy.textContent = 'Copy ' + offer.code;
        copy.addEventListener('click', function () {
          try { sessionStorage.setItem('pf:discount-code', offer.code); } catch (_) {}
          var copied = navigator.clipboard && navigator.clipboard.writeText
            ? navigator.clipboard.writeText(offer.code)
            : Promise.resolve();
          Promise.resolve(copied).catch(function () {}).then(function () {
            copy.textContent = 'Copied ' + offer.code;
            window.setTimeout(function () { copy.textContent = 'Copy ' + offer.code; }, 1800);
          });
        });
        body.appendChild(copy);
      }
      card.appendChild(body);
      fragment.appendChild(card);
    });
    list.replaceChildren(fragment);
    list.closest('[data-pdp-offers-shell]').hidden = offers.length === 0;
  }

  function hydrate(list) {
    if (list.__pfOffersLoading) return;
    var url = configUrl();
    if (!url) return;
    list.__pfOffersLoading = true;
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('offer_config_unavailable'); return response.json(); })
      .then(function (body) {
        var config = body && body.config;
        if (!config || !config.publication || !config.publication.eligible) return;
        render(list, bannersFor(config));
      })
      .catch(function () { /* Fail closed: stale promotional claims stay hidden. */ })
      .finally(function () { list.__pfOffersLoading = false; });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pdp-offers]').forEach(hydrate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
